import type { CustomerProfile, PlanInputs } from '../types';

const STORAGE_KEY = 'plan-calculator-profiles-v1';

export function listProfiles(): CustomerProfile[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed as CustomerProfile[];
  } catch {
    return [];
  }
}

function saveAll(profiles: CustomerProfile[]): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(profiles));
}

function newId(): string {
  return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
}

export function saveProfile(name: string, inputs: PlanInputs, notes = ''): CustomerProfile {
  const now = new Date().toISOString();
  const profile: CustomerProfile = {
    id: newId(),
    name,
    inputs,
    notes,
    createdAt: now,
    updatedAt: now,
  };
  const all = listProfiles();
  all.push(profile);
  saveAll(all);
  return profile;
}

export function updateProfile(id: string, patch: Partial<Omit<CustomerProfile, 'id' | 'createdAt'>>): CustomerProfile | null {
  const all = listProfiles();
  const idx = all.findIndex((p) => p.id === id);
  if (idx === -1) return null;
  const prev = all[idx];
  if (!prev) return null;
  const updated: CustomerProfile = {
    ...prev,
    ...patch,
    id: prev.id,
    createdAt: prev.createdAt,
    updatedAt: new Date().toISOString(),
  };
  all[idx] = updated;
  saveAll(all);
  return updated;
}

export function deleteProfile(id: string): void {
  const all = listProfiles().filter((p) => p.id !== id);
  saveAll(all);
}

export function exportJSON(): string {
  return JSON.stringify(listProfiles(), null, 2);
}

export function importJSON(json: string): { ok: boolean; count: number; error?: string } {
  try {
    const parsed = JSON.parse(json);
    if (!Array.isArray(parsed)) return { ok: false, count: 0, error: '配列形式ではありません' };
    saveAll(parsed as CustomerProfile[]);
    return { ok: true, count: parsed.length };
  } catch (e) {
    return { ok: false, count: 0, error: e instanceof Error ? e.message : String(e) };
  }
}
